import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  private activeFilters: { [url: string]: BehaviorSubject<boolean> } = {};

  constructor() {}

  toggleFilter(url: string): void {
    if (!this.activeFilters[url]) {
      this.activeFilters[url] = new BehaviorSubject<boolean>(false);
    }
    const currentValue = this.activeFilters[url].value;
    this.activeFilters[url].next(!currentValue);
  }

  getFilterState(url: string): BehaviorSubject<boolean> {
    if (!this.activeFilters[url]) {
      this.activeFilters[url] = new BehaviorSubject<boolean>(false);
    }
    return this.activeFilters[url];
  }

  closeFilter(url: string): void {
    if (this.activeFilters[url]) {
      this.activeFilters[url].next(false); 
    }
  }

}
